import React from "react";
import { projects } from "../../database/database";
import ProjectCard from "components/ProjectCard";

const Project = () => {
  return (
    <div className="new-tab-content-container">
      <div className="projects-wrapper">
        <ProjectCard projects={projects} />
      </div>
    </div>
  );
};

export default Project;
